import React, { useState, useEffect, useMemo } from 'react';
import { CloseCircleOutlined, CheckCircleOutlined } from '@ant-design/icons';

import { Typography, notification, Row, Col, Card, Divider, Button, Space } from 'antd';

import { FormattedMessage, useIntl } from 'react-intl';

import Core from "../../../../../common/Core";

import _service from '@netuno/service-client';

import "./index.less";

import Modal from './Modal';

const { Meta } = Card;
const { Title } = Typography;

const langContext = 'reserved-area.marketplace.service';

export default ({ serviceUID, radius, filterCards }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [modalUID, setModalUID] = useState(null);
    const [price, setPrice] = useState([]);

    useEffect(() => {
        setLoading(true);
        const data = { radius, filterCards };
        if (serviceUID) {
            data.service_uid = serviceUID;
        }
        _service({
            method: 'GET',
            url: '/marketplace/service/list',
            data,
            success: (response) => {
                setData(response.json);
                console.log(response.json)
                setLoading(false);

                const prices = response.json.map((item) => item.price).sort((a, b) => a - b)
                setPrice([...prices])

            },
            fail: (e) => {
                setLoading(false);
                notification["error"]({
                    message: 'Não foi possivel carregar os dados.',
                });
            },

        });
    }, [serviceUID, radius, filterCards]);

    const intl = useIntl();

    const onShowModal = (item) => {
        setIsModalVisible(true);
        setModalUID(item.uid);
    }

    const onModalClose = () => {
        setIsModalVisible(false);
    }

    return (
        <div className="card-service">
            <Row gutter={16, 16} justify="start">
                {data.map((item) => (
                    < Space size={[8, 16]} direction="horizontal" wrap >
                        <Col xs={20} sm={4} md={8} lg={8} xl={{ span: 6, offset: 1 }}>
                            <Card
                                style={{ width: 300 }}
                                actions={[
                                    <Button type="link" onClick={() => onShowModal(item)}>
                                        <FormattedMessage id={`${langContext}.button.detail`} />
                                    </Button>
                                    ,]}>
                                <Meta
                                    title={item.client.name}
                                />
                                <Divider />
                                <p><span>{intl.formatMessage({ id: langContext + '.fields.code' })}:</span> {item.service.code}</p>
                                <p><span>{intl.formatMessage({ id: langContext + '.fields.distance' })}:</span> {Core.numeral(item.distance)}</p>
                                <p><span>{intl.formatMessage({ id: langContext + '.fields.price' })}:</span> &euro; {Core.numeral(item.price)}</p>
                                <p><span>{intl.formatMessage({ id: langContext + '.fields.estimated-date' })}:</span> {item.estimated_date}</p>
                                <p><span>{intl.formatMessage({ id: 'reserved-area.marketplace.fields.own-transport' })}:</span>
                                    {item.own_transport == true ? <CheckCircleOutlined style={{ color: "#52c41a", marginLeft: '8px' }} /> : <CloseCircleOutlined style={{ color: "#f5222d", marginLeft: '8px' }} />}
                                </p>
                                <p><span>{intl.formatMessage({ id: langContext + '.fields.waste-type' })}:</span> {item.service.waste_type.description[intl.locale.split('-')[0]]}</p>
                                <p><span>{intl.formatMessage({ id: langContext + '.fields.service-type' })}:</span> {item.service.service_type.description[intl.locale.split('-')[0]]}</p>
                                <p><span>{intl.formatMessage({ id: 'components.measurement-unit-select.title' })}:</span> {item.measurement_unit.description[intl.locale.split('-')[0]]} </p>
                            </Card>
                        </Col>
                    </Space>
                ))}
            </Row>
            {isModalVisible && <Modal uid={modalUID} radius={radius} onClose={onModalClose} />}
        </div >
    )
}